import { useEffect } from 'react';

const useRenderStocktwitsEmbeds = (slug: string, update: boolean) => {
  useEffect(() => {
    (window as any)?.__stwts?.loadStocktwitsEmbeds();
  }, [slug, update]);
};

export default useRenderStocktwitsEmbeds;
